<template>
    <section class="signin-rules" aria-labelledby="signin-rules-title">
        <div class="rules-heading">
            <div class="rules-heading-content">
                <div class="rules-title-line">
                    <img class="rules-title-icon" :src="images.ruleLeft" width="21" height="14" alt="" aria-hidden="true" />
                    <h2 id="signin-rules-title">奖励与签到规则</h2>
                    <img class="rules-title-icon" :src="images.ruleRight" width="21" height="14" alt="" aria-hidden="true" />
                </div>
                <p>奖励由每日基础奖励和连续签到额外奖励组成。</p>
            </div>
        </div>

        <div v-if="rewardRows.length" class="reward-table" role="table" aria-label="签到奖励">
            <div class="reward-row reward-header" role="row">
                <span role="columnheader">达成条件</span>
                <span role="columnheader">积分</span>
                <span role="columnheader">成长值</span>
            </div>
            <div v-for="row in rewardRows" :key="row.key" class="reward-row" role="row">
                <strong role="cell">{{ row.title }}</strong>
                <span role="cell">{{ rewardValue(row.point, "积分") }}</span>
                <span role="cell">{{ rewardValue(row.growth, "成长值") }}</span>
            </div>
        </div>
        <div v-else class="empty-reward">暂无奖励规则</div>

        <ol class="rule-list">
            <li>每位客户每日可签到一次，签到成功后每日基础奖励自动到账。</li>
            <li>连续签到达到指定天数时，可在基础奖励之外获得对应的额外奖励。</li>
            <li>连续签到 {{ cycle }} 天为一个周期；签满周期或签到中断后，连续天数将重新计算。</li>
        </ol>
    </section>
</template>

<script>
function toNumber(value) {
    const number = Number(value)
    return Number.isFinite(number) ? number : 0
}

export default {
    name: "SigninRules",
    props: {
        rules: {
            type: Array,
            default: () => []
        },
        cycle: {
            type: Number,
            default: 0
        },
        images: {
            type: Object,
            required: true
        }
    },
    computed: {
        rewardRows() {
            return this.rules.map((item, index) => ({
                key: index === 0 ? "daily" : `day-${item.day}`,
                title: index === 0 ? "每日签到" : `连续签到 ${item.day} 天`,
                point: toNumber(item.point),
                growth: toNumber(item.growth)
            }))
        }
    },
    methods: {
        rewardValue(value, unit) {
            return value ? `+${value} ${unit}` : "—"
        }
    }
}
</script>

<style lang="scss" scoped>
.signin-rules {
    margin-top: 16px;
    padding: 24px 28px 28px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #ffffff;
}

.rules-heading {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    text-align: center;
}

.rules-title-line {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.rules-heading h2 {
    margin: 0;
    color: #303133;
    font-size: 18px;
    line-height: 1.4;
}

.rules-heading p {
    margin: 4px 0 0;
    color: #606266;
    font-size: 13px;
}

.rules-title-icon {
    width: 21px;
    height: 14px;
    object-fit: contain;
}

.reward-table {
    overflow: hidden;
    border: 1px solid #ebeef5;
    border-radius: 6px;
}

.reward-row {
    display: grid;
    grid-template-columns: minmax(220px, 1.5fr) repeat(2, minmax(140px, 1fr));
    min-height: 48px;
    border-top: 1px solid #ebeef5;
}

.reward-row:first-child {
    border-top: 0;
}

.reward-row > * {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-left: 1px solid #ebeef5;
    color: #606266;
    font-size: 13px;
}

.reward-row > *:first-child {
    border-left: 0;
}

.reward-row strong {
    color: #303133;
    font-weight: 500;
}

.reward-header {
    min-height: 42px;
    background: #f5f7fa;
}

.reward-header > * {
    color: #606266;
    font-weight: 600;
}

.empty-reward {
    padding: 30px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    color: #606266;
    text-align: center;
}

.rule-list {
    margin: 20px 0 0;
    padding-left: 20px;
    color: #606266;
}

.rule-list li {
    list-style: decimal;
    margin-top: 8px;
    line-height: 1.7;
}

@media (max-width: 900px) {
    .reward-row {
        grid-template-columns: minmax(160px, 1.3fr) repeat(2, minmax(100px, 1fr));
    }
}
</style>
